import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { UiRoutingModule } from '@app/ui/ui-routing.module';
@NgModule({
    imports: [ RouterModule, CommonModule,UiRoutingModule ],
    declarations: [ NavbarComponent ],
    exports: [ NavbarComponent ]
})

export class NavbarModule {}
